/** @jsx jsx */
import React from 'react'
import { Box, Input, jsx, Label, Text } from 'theme-ui'

const FormInputWithLabel = React.forwardRef(
  ({ name, label, error, ...props }, ref) => {
    return (
      <Box>
        <Box sx={{ position: 'relative', height: '100%', width: '100%' }}>
          <Input
            sx={{
              backgroundColor: 'white',
              border: '1px solid',
              borderColor: 'greyDark',
              borderRadius: 0,
              color: 'black',
              fontFamily: 'body',
              fontSize: '18px',
              letterSpacing: '0.5px',
              lineHeight: '28px',
              width: '100%',
              padding: '11px 14px',
              '::placeholder': {
                color: 'greyDark',
              },
              ':not(:placeholder-shown)': {
                padding: '17px 14px 5px',
              },
              ':placeholder-shown + label': {
                display: 'none',
              },
            }}
            name={name}
            ref={ref}
            {...props}
          />
          <Label
            htmlFor={name}
            sx={{
              color: 'greyDark',
              fontSize: '12px',
              fontWeight: 'medium',
              position: 'absolute',
              top: '-1px',
              left: '14px',
              pointerEvents: 'none',
            }}
          >
            {label}
          </Label>
        </Box>
        {error && (
          <Text as="p" mt={1} variant="error">
            {error}
          </Text>
        )}
      </Box>
    )
  }
)
export default FormInputWithLabel
